(function () {
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function initTilt(el) {
    // If it's an <img>, great. If it's a wrapper, we still tilt the wrapper.
    let dragging = false;
    let rotX = 0, rotY = 0;
    let lastX = 0, lastY = 0;

    // Auto motion (idle)
    let t = 0;
    let idleOn = true;
    let idleTimer = null;

    function apply() {
      el.style.transform = `perspective(900px) rotateX(${rotX}deg) rotateY(${rotY}deg)`;
    }

    function startIdle() {
      if (idleTimer) return;
      idleTimer = setInterval(() => {
        if (!idleOn || dragging) return;
        t += 0.03;
        // gentle motion
        rotY = Math.sin(t) * 8;
        rotX = Math.cos(t) * 3;
        apply();
      }, 30);
    }

    function stopIdle() {
      idleOn = false;
      if (idleTimer) { clearInterval(idleTimer); idleTimer = null; }
    }

    function resumeIdleAfter(ms) {
      if (idleTimer) { clearInterval(idleTimer); idleTimer = null; }
      setTimeout(() => { idleOn = true; startIdle(); }, ms);
    }

    function getX(e) { return (e.touches ? e.touches[0].clientX : e.clientX); }
    function getY(e) { return (e.touches ? e.touches[0].clientY : e.clientY); }

    function onDown(e) {
      dragging = true;
      stopIdle();
      lastX = getX(e);
      lastY = getY(e);
      if (el.setPointerCapture && e.pointerId != null) el.setPointerCapture(e.pointerId);
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      const x = getX(e), y = getY(e);
      const dx = x - lastX;
      const dy = y - lastY;

      // Sensitivity (change these if you want faster/slower)
      rotY += dx * 0.25;
      rotX -= dy * 0.15;

      rotX = clamp(rotX, -18, 18);
      rotY = ((rotY % 360) + 360) % 360;

      lastX = x;
      lastY = y;
      apply();
      e.preventDefault();
    }

    function onUp() {
      dragging = false;
      // resume auto motion after 1 second
      resumeIdleAfter(1000);
    }

    function onLeave() {
      dragging = false;
      // softly return to neutral, then idle
      stopIdle();
      const startX = rotX, startY = rotY;
      const steps = 18;
      let s = 0;
      const anim = setInterval(() => {
        s++;
        rotX = startX + (0 - startX) * (s / steps);
        rotY = startY + (0 - startY) * (s / steps);
        apply();
        if (s >= steps) {
          clearInterval(anim);
          resumeIdleAfter(300);
        }
      }, 16);
    }

    el.addEventListener('pointerdown', onDown);
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerup', onUp);
    el.addEventListener('pointercancel', onUp);
    el.addEventListener('mouseleave', onLeave);

    // Start idle immediately
    apply();
    startIdle();
  }

  function boot() {
    document.querySelectorAll('[data-tilt3d="true"]').forEach((el) => {
      if (el.dataset.tilt3dInit === "1") return;
      el.dataset.tilt3dInit = "1";
      initTilt(el);
    });
  }

  // Run on load and on Shopify section reloads
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
